module.exports = __webpack_public_path__ + "static/media/C_F03.25225bed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/C_F03.png
// module id = 126
// module chunks = 0